import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/Modal'

import { SubirArchivo } from './SubirArchivos'
import styles from './Upload.module.css'

const LIMIT_UPLOAD = 10

export const ModalUpload = ({
  show,
  onClose,
  idDoc,
  idPerfil,
  idTipo,
  onCarga,
  adjuntoPendiente,
  maxFiles
}) => {
  const mostrarContador = Array.isArray(adjuntoPendiente)
  const cantidad = mostrarContador ? adjuntoPendiente.length : 0
  const limite = maxFiles ?? LIMIT_UPLOAD

  return (
    <Modal
      show={show}
      onHide={onClose}
      animation={false}
      centered
      className={styles.modalApilado}
      backdropClassName={styles.backdropApilado}
      contentClassName={styles.modalContent}
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title as="div" className={styles.modalTitulo}>
          <span className={styles.modalIcono} aria-hidden="true">
            <i className="fa fa-paperclip" />
          </span>
          <h3 className={styles.modalTituloTexto}>Adjuntar archivo</h3>
        </Modal.Title>
      </Modal.Header>
      <div className={styles.modalBody}>
        <SubirArchivo
          idUsuario={idPerfil}
          idTipo={idTipo || '1'}
          idDoc={idDoc}
          onCarga={onCarga}
          adjuntoPendiente={adjuntoPendiente}
          maxFiles={maxFiles}
        />
      </div>
      <div className={styles.modalFooter}>
        {mostrarContador && (
          <span className={styles.modalContador}>
            {cantidad} de {limite} archivo{limite !== 1 ? 's' : ''} adjunto
            {limite !== 1 ? 's' : ''}
          </span>
        )}
        <button type="button" className={styles.botonListo} onClick={onClose}>
          Listo
        </button>
      </div>
    </Modal>
  )
}

ModalUpload.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  idDoc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idPerfil: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idTipo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCarga: PropTypes.func,
  adjuntoPendiente: PropTypes.array,
  maxFiles: PropTypes.number
}
